<template>
  <div class="my-activity-page">
    <div class="page-header">
      <h1 class="page-title">My Activity</h1>
      <p class="page-subtitle">Track your interactions and engagement across the platform</p>
    </div>

    <div class="activity-container" v-loading="activityLoading" element-loading-text="Loading your activity...">
      <div class="activity-content">
        <div class="activity-filters">
              <el-select v-model="allActivityFilter" placeholder="Filter by type" clearable>
                <el-option label="All" value=""></el-option>
                <el-option-group label="Cards">
                  <!-- Pinned Cards moved to Starred Items page -->
                  <el-option value="wrongAnswer" label="Incorrectly Answered Cards">
                    <i class="el-icon-circle-close" style="color: #F56C6C;"></i>
                    <span style="margin-left: 8px;">Incorrectly Answered Cards</span>
                  </el-option>
                </el-option-group>
                <el-option-group v-if="false" label="Stacks">
                  <!-- <el-option value="like" label="Liked Stacks">
                    <i class="el-icon-thumb" style="color: #1159AF;"></i>
                    <span style="margin-left: 8px;">Liked Stacks</span>
                  </el-option>
                  <el-option value="pin" label="Pinned Stacks">
                    <i class="el-icon-collection-tag" style="color: #1159AF;"></i>
                    <span style="margin-left: 8px;">Pinned Stacks</span>
                  </el-option>
                  <!-- <el-option value="mark" label="Starred Stacks">
                    <i class="el-icon-star-off" style="color: #1159AF;"></i>
                    <span style="margin-left: 8px;">Starred Stacks</span>
                  </el-option>
                  <el-option value="comment" label="Commented Stacks">
                    <i class="el-icon-chat-dot-round" style="color: #1159AF;"></i>
                    <span style="margin-left: 8px;">Commented Stacks</span>
                  </el-option>
                  <el-option value="share" label="Shared Stacks">
                    <i class="el-icon-share" style="color: #1159AF;"></i>
                    <span style="margin-left: 8px;">Shared Stacks</span>
                  </el-option> -->
                </el-option-group>
                <!-- <el-option-group label="Knowit Cards">
                  <el-option value="starredKnowit" label="Starred Cards">
                    <i class="el-icon-star-on" style="color: #F7BA2A;"></i>
                    <span style="margin-left: 8px;">Starred Cards</span>
                  </el-option>
                </el-option-group> -->
                <!-- <el-option-group label="Decks">
                  <el-option value="starredDeck" label="Starred Decks">
                    <i class="el-icon-star-on" style="color: #F7BA2A;"></i>
                    <span style="margin-left: 8px;">Starred Decks</span>
                  </el-option>
                </el-option-group> -->
              </el-select>
            </div>
            <div class="activity-list">
              <div v-for="activity in filteredAllActivity" :key="activity.id">
                <LikeCard 
                  v-if="activity.type === 'like'"
                  :like="activity.data"
                  type="like"
                  @remove="removeLike"
                />
                <PinCard 
                  v-else-if="activity.type === 'pin'"
                  :pin="activity.data"
                  @remove="removePin"
                />
                <PinAnswerCard
                  v-else-if="activity.type === 'pinAnswer'"
                  :pinAnswer="activity.data"
                  @remove="removePinAnswer"
                />
                <WrongAnswerCard
                  v-else-if="activity.type === 'wrongAnswer'"
                  :wrongAnswer="activity.data"
                  @remove="removeWrongAnswer"
                />
                <LikeCard
                  v-else-if="activity.type === 'mark'"
                  :like="activity.data"
                  type="mark"
                  @remove="removeMarkedPost"
                />
                <CommentCard 
                  v-else-if="activity.type === 'comment'"
                  :comment="activity.data"
                  @remove="removeComment"
                />
                <ShareCard
                  v-else-if="activity.type === 'share'"
                  :share="activity.data"
                  @remove="removeShare"
                />
                <StarredKnowitCard
                  v-else-if="activity.type === 'starredKnowit'"
                  :starredCard="activity.data"
                  @view="viewStarredCard"
                  @unstar="unstarCard"
                />
                <StarredDeckCard
                  v-else-if="activity.type === 'starredDeck'"
                  :starredDeck="activity.data"
                  @view="viewDeck"
                  @unstar="unstarDeck"
                />
              </div>
              <div v-if="filteredAllActivity.length === 0" class="empty-state">
                <i class="el-icon-document"></i>
                <p>No activity found</p>
              </div>
            </div>
      </div>
    </div>

    <!-- Card Read View Dialog -->
    <el-dialog
      :visible.sync="readCardDialogVisible"
      width="850px"
      :show-close="true"
      custom-class="card-read-dialog"
      @close="readCardDialogVisible = false; selectedCardForReading = null"
    >
      <DirectReadCard
        v-if="selectedCardForReading"
        :card="selectedCardForReading"
        @close="readCardDialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import LikeCard from './components/LikeCard.vue'
import PinCard from './components/PinCard.vue'
import PinAnswerCard from './components/PinAnswerCard.vue'
import WrongAnswerCard from './components/WrongAnswerCard.vue'
import CommentCard from './components/CommentCard.vue'
import ShareCard from './components/ShareCard.vue'
import StarredKnowitCard from './components/StarredKnowitCard.vue'
import StarredDeckCard from './components/StarredDeckCard.vue'
import DirectReadCard from '@/components/DirectReadCard.vue'
import { postRequest } from '@/apis/front'

export default {
  name: 'MyActivity',
  components: {
    LikeCard,
    PinCard,
    PinAnswerCard,
    WrongAnswerCard,
    CommentCard,
    ShareCard,
    StarredKnowitCard,
    StarredDeckCard,
    DirectReadCard
  },
  data() {
    return {
      activityLoading: true,
      allActivityFilter: '',

      myLikes: [],

      myPins: [],

      myPinAnswers: [],

      myWrongAnswers: [],

      myComments: [],
      
      myMarkedPosts: [],

      myStarredKnowits: [],

      myStarredDecks: [],

      // Read card dialog
      readCardDialogVisible: false,
      selectedCardForReading: null,

      myShares: []
    }
  },
  computed: {
    filteredAllActivity() {
      if (!this.allActivityFilter) {
        return this.allActivity
      }
      return this.allActivity.filter(activity => activity.type === this.allActivityFilter)
    },
    
    allActivity() {
      const activities = []
      
      // Hidden categories: likes, shares, marks, starredKnowits
      // this.myLikes.forEach(like => {
      //   activities.push({ id: `like_${like.id}`, type: 'like', timestamp: like.timestamp, data: like })
      // })
      // Pinned Stacks hidden
      // this.myPins.forEach(pin => {
      //   activities.push({ id: `pin_${pin.id}`, type: 'pin', timestamp: pin.timestamp, data: pin })
      // })
      // this.myPinAnswers.forEach(pinAnswer => {
      //   activities.push({ id: `pinAnswer_${pinAnswer.id}`, type: 'pinAnswer', timestamp: pinAnswer.timestamp, data: pinAnswer })
      // })
      // this.myShares.forEach(share => {
      //   activities.push({ id: `share_${share.id}`, type: 'share', timestamp: share.timestamp, data: share })
      // })
      // this.myMarkedPosts.forEach(mark => {
      //   activities.push({ id: `mark_${mark.id}`, type: 'mark', timestamp: mark.timestamp, data: mark })
      // })
      // this.myStarredKnowits.forEach(starredKnowit => {
      //   activities.push({ id: `starredKnowit_${starredKnowit.id}`, type: 'starredKnowit', timestamp: starredKnowit.timestamp, data: starredKnowit })
      // })

      // Add wrong answer cards as activities
      this.myWrongAnswers.forEach(wrongAnswer => {
        activities.push({
          id: `wrongAnswer_${wrongAnswer.id}`,
          type: 'wrongAnswer',
          timestamp: wrongAnswer.timestamp,
          data: wrongAnswer.data
        })
      })

      // Add comments as activities
      this.myComments.forEach(comment => {
        activities.push({
          id: `comment_${comment.id}`,
          type: 'comment',
          timestamp: comment.timestamp,
          data: comment
        })
      })

      // Starred Decks moved to Starred Items page
      // this.myStarredDecks.forEach(starredDeck => {
      //   activities.push({
      //     id: `starredDeck_${starredDeck.id}`,
      //     type: 'starredDeck',
      //     timestamp: starredDeck.timestamp,
      //     data: starredDeck
      //   })
      // })

      // Sort by timestamp in descending order (newest first)
      return activities.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    }
  },
  mounted() {
    // Load user activity data from API
    this.loadActivityData()
  },
  methods: {
    async loadActivityData() {
      try {
        // TODO: Replace with actual API calls
        // const response = await this.$api.getUserActivity()
        // this.allActivity = response.data.allActivity
        // await this.fetchMyLikes()
        // await this.fetchMyPins()
        // await this.fetchMyMarkedPosts()
        await this.fetchMyComments()
        // await this.fetchMyShares()
        await this.fetchMyWrongAnswerCards()
        // await this.fetchMyStarredKnowits()
        // await this.fetchMyStarredDecks()
      } catch (error) {
        console.error('Failed to load activity data:', error)
        this.$message.error('Failed to load activity data')
      } finally {
        this.activityLoading = false
      }
    },
    
    async fetchMyLikes() {
      try {
        const params = {
          user_id: this.$store.state.user_id,
          time_stamp: Math.floor(Date.now() / 1000) // Current timestamp in seconds
        }
        
        const response = await postRequest('getMyThumbPosts', params)
        
        if (response.data.code === 0) {
          // Transform the data to match the expected structure for LikeCard component
          this.myLikes = (response.data.data || []).map((post, index) => ({
            id: (post._id && (post._id.$oid || post._id.$id)) || index,
            timestamp: new Date((post.time_stamp || post.create_time || Date.now() / 1000) * 1000).toISOString(),
            post: {
              id: post._id && (post._id.$oid || post._id.$id),
              title: post.title || 'Untitled Post',
              author: post.user_name || 'Unknown Author',
              author_id: post.user_id || null,
              authorAvatar: post.authorAvatar || null,
              content: (post.answers && post.answers[0] && post.answers[0].content) || post.content || 'No content available',
              likes: post.thumb_up_count || 0,
              comments: post.comment_count || 0
            }
          }))
        } else {
          console.error('Failed to fetch liked posts:', response.data.msg)
          this.$message.error(response.data.msg || 'Failed to fetch liked posts')
        }
      } catch (error) {
        console.error('Error fetching liked posts:', error)
        this.$message.error('Failed to fetch liked posts')
      }
    },
    
    async fetchMyPins() {
      try {
        const params = {
          user_id: this.$store.state.user_id
        }
        
        const response = await postRequest('getUserStarPostAnswers', params)
        
        if (response.data.code === 0) {
          const posts = response.data.data || []
          
          // Debug: Log the structure of the first post to understand the data format
          if (posts.length > 0) {
            console.log('First post structure:', posts[0])
            console.log('view_info structure:', posts[0].view_info)
            console.log('starred_answers type:', typeof (posts[0].view_info && posts[0].view_info.starred_answers))
            console.log('starred_answers value:', posts[0].view_info && posts[0].view_info.starred_answers)
          }
          
          // Create myPins structure (per post view)
          this.myPins = posts.map((post, index) => {
            const starredAnswers = (post.view_info && post.view_info.starred_answers) || {}
            const pinned_answers = []
            
            // Iterate through starred_answers keys (uniqueCode) and fetch matched answers from post.answers
            if (typeof starredAnswers === 'object' && starredAnswers !== null) {
              Object.keys(starredAnswers).forEach((uniqueCode, keyIndex) => {
                // Find the answer that matches this uniqueCode, or fall back to index-based match
                let answer = post.answers && post.answers.find(ans => ans.uniqueCode === uniqueCode)
                if (!answer && post.answers && post.answers.length > 0) {
                  // Try matching by numeric index if uniqueCode is a number
                  const idx = parseInt(uniqueCode)
                  if (!isNaN(idx) && idx >= 0 && idx < post.answers.length) {
                    answer = post.answers[idx]
                  }
                }

                if (answer) {
                  // Determine content based on content_type
                  let displayContent = 'No content available'
                  if (answer.content_type === 'text') {
                    displayContent = answer.content || 'No content available'
                  } else if (answer.content_type === 'quiz') {
                    displayContent = (answer.quiz_content && answer.quiz_content.question) || 'No content available'
                  }

                  pinned_answers.push({
                    id: (answer._id && (answer._id.$oid || answer._id.$id)) || `${post._id && (post._id.$oid || post._id.$id)}_${uniqueCode}`,
                    content: answer.content || 'No content available',
                    quiz_content: displayContent,
                    contentType: answer.content_type || 'text',
                    answerIndex: post.answers ? post.answers.indexOf(answer) : 0,
                    uniqueCode: uniqueCode,
                    timestamp: new Date(starredAnswers[uniqueCode] * 1000).toISOString()
                  })
                }
              })
            }

            // Get the earliest pin timestamp from all pinned answers
            const pinTimestamps = Object.values(starredAnswers).filter(ts => ts)
            const earliestPinTime = pinTimestamps.length > 0 ? Math.min(...pinTimestamps) : null

            return {
              id: (post._id && (post._id.$oid || post._id.$id)) || index,
              collection_id: post.collection_id || null,
              timestamp: earliestPinTime ? new Date(earliestPinTime * 1000).toISOString() : new Date().toISOString(),
              pinned_answers: pinned_answers,
              postTitle: post.title || 'Untitled Post',
              author: post.user_name || 'Unknown Author',
              authorAvatar: post.authorAvatar || null,
              likes: post.thumb_up_count || 0
            }
          })
          
          // Create myPinAnswers structure (per answer view)
          this.myPinAnswers = []
          posts.forEach((post) => {
            const starredAnswers = (post.view_info && post.view_info.starred_answers) || {}
            
            // Handle starredAnswers as an object where keys are unique codes and values are action times
            if (typeof starredAnswers === 'object' && starredAnswers !== null) {
              Object.keys(starredAnswers).forEach((uniqueCode) => {
                // Extract answer index from unique code or use a fallback
                // Assuming uniqueCode might contain the answer index or we need to find it differently
                
                const answer = post.answers && post.answers.find(ans => ans.uniqueCode === uniqueCode) 
                
                if (answer) {
                  this.myPinAnswers.push({
                    id: `${post._id && (post._id.$oid || post._id.$id)}_${uniqueCode}`,
                    timestamp: new Date(starredAnswers[uniqueCode] * 1000).toISOString(),
                    answer: {
                      id: (answer._id && (answer._id.$oid || answer._id.$id)) || `${post._id && (post._id.$oid || post._id.$id)}_${uniqueCode}`,
                      content: answer.content || 'No content available',
                      quiz_content: answer.quiz_content || 'No content available',
                      contentType: answer.content_type || 'text',
                      postTitle: post.title || 'Untitled Post',
                      postId: post._id && (post._id.$oid || post._id.$id),
                      collection_id: post.collection_id || null,
                      author: post.user_name || 'Unknown Author',
                      likes: post.thumb_up_count || 0,
                      answerIndex: post.answers && post.answers.indexOf(answer) || 0,
                      uniqueCode: uniqueCode
                    }
                  })
                }
              })
              console.log('myPinAnswers', this.myPinAnswers)  
            } else {
              // If starredAnswers is not an object, log it for debugging
              console.log('starredAnswers is not an object:', starredAnswers, 'for post:', post._id && (post._id.$oid || post._id.$id))
            }
          })
        } else {
          console.error('Failed to fetch pinned posts:', response.data.msg)
          this.$message.error(response.data.msg || 'Failed to fetch pinned posts')
        }
      } catch (error) {
        console.error('Error fetching pinned posts:', error)
        this.$message.error('Failed to fetch pinned posts')
      }
    },
    
    removeLike(likeId) {
      this.myLikes = this.myLikes.filter(like => like.id !== likeId)
    },
    removePin(pinId) {
      this.myPins = this.myPins.filter(pin => pin.id !== pinId)
    },
    removeComment(commentId) {
      this.myComments = this.myComments.filter(comment => comment.id !== commentId)
    },
    async removeShare(shareId) {
      try {
        const response = await postRequest('deleteShare', {
          share_id: shareId,
          user_id: this.$store.state.user_id
        })
        
        if (response.data.code === 0) {
          this.myShares = this.myShares.filter(share => share.id !== shareId)
          this.$message.success('Share removed successfully')
        } else {
          this.$message.error(response.data.msg || 'Failed to remove share')
        }
      } catch (error) {
        console.error('Error removing share:', error)
        this.$message.error('Failed to remove share')
      }
    },
    removePinAnswer(pinAnswerId) {
      this.myPinAnswers = this.myPinAnswers.filter(pinAnswer => pinAnswer.id !== pinAnswerId)
    },
    
    async fetchMyMarkedPosts() {
      try {
        const params = {
          user_id: this.$store.state.user_id,
          time_stamp: Math.floor(Date.now() / 1000) // Current timestamp in seconds
        }
        
        const response = await postRequest('getMyMarkPosts', params)
        
        if (response.data.code === 0) {
          // Transform the data to match the expected structure for LikeCard component
          this.myMarkedPosts = (response.data.data || []).map((post, index) => ({
            id: (post._id && (post._id.$oid || post._id.$id)) || index,
            timestamp: new Date((post.time_stamp || post.create_time || Date.now() / 1000) * 1000).toISOString(),
            post: {
              id: post._id && (post._id.$oid || post._id.$id),
              title: post.title || 'Untitled Post',
              author: post.user_name || 'Unknown Author',
              author_id: post.user_id || null,
              content: (post.answers && post.answers[0] && post.answers[0].content) || post.content || 'No content available',
              likes: post.thumb_up_count || 0,
              comments: post.comment_count || 0
            }
          }))
        } else {
          console.error('Failed to fetch marked posts:', response.data.msg)
          this.$message.error(response.data.msg || 'Failed to fetch marked posts')
        }
      } catch (error) {
        console.error('Error fetching marked posts:', error)
        this.$message.error('Failed to fetch marked posts')
      }
    },
    
    removeMarkedPost(markId) {
      this.myMarkedPosts = this.myMarkedPosts.filter(mark => mark.id !== markId)
    },
    
    async fetchMyComments() {
      try {
        const params = {
          user_id: this.$store.state.user_id,
          page: 1,
          limit: 50
        }
        
        const response = await postRequest('getMyCommented', params)
        
        if (response.data.code === 0) {
          const data = response.data.data
          this.myComments = data.comments || []
        } else {
          console.error('Failed to fetch comments:', response.data.msg)
          this.$message.error(response.data.msg || 'Failed to fetch comments')
        }
      } catch (error) {
        console.error('Error fetching comments:', error)
        this.$message.error('Failed to fetch comments')
      }
    },
    
    async fetchMyShares() {
      try {
        const response = await postRequest('getMySharePosts', {
          user_id: this.$store.state.user_id,
          page: 1,
          limit: 50
        })
        
        if (response.data.code === 0) {
          // Transform the backend data to match ShareCard component expectations
          this.myShares = (response.data.data.shares || []).map(shareItem => ({
            id: shareItem.share_id,
            timestamp: new Date(shareItem.shared_at * 1000).toISOString(), // Convert Unix timestamp to ISO string
            post: {
              id: shareItem.post.post_id,
              title: shareItem.post.title,
              author: shareItem.post.user_name, // Map user_name to author
              author_id: shareItem.post.user_id, // Add author_id for navigation
              content: shareItem.post.preview ? shareItem.post.preview.content : 'No preview available',
              shares: shareItem.post.share_count
            }
          }))
        } else {
          console.error('Failed to fetch shared posts:', response.data.msg)
          this.$message.error(response.data.msg || 'Failed to fetch shared posts')
        }
      } catch (error) {
        console.error('Error fetching shared posts:', error)
        this.$message.error('Failed to fetch shared posts')
      }
    },

    async fetchMyWrongAnswerCards() {
      try {
        const response = await postRequest('getMyWrongAnswerCards', {
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.myWrongAnswers = (response.data.data || []).map(card => ({
            id: card._id?.$oid || card._id?.$id || card.id,
            timestamp: card.create_time * 1000, // Convert to milliseconds
            data: {
              ...card,
              answer_card: {
                ...card.answer_card,
                author: card.user_name,
                answerIndex: card.answer_card_index || card.asnwer_card_index, // Check both spellings
                postTitle: card.post_title,
                postId: card.post_id
              }
            }
          }))
        } else {
          console.error('Failed to fetch wrong answer cards:', response.data.msg)
        }
      } catch (error) {
        console.error('Error fetching wrong answer cards:', error)
      }
    },

    async removeWrongAnswer(id) {
      try {
        const response = await postRequest('removeWrongAnswerCard', {
          user_id: this.$store.state.user_id,
          card_id: id
        })

        if (response.data.code === 0) {
          this.myWrongAnswers = this.myWrongAnswers.filter(item => item.id !== id)
          this.$message.success('Wrong answer card removed')
        } else {
          this.$message.error(response.data.msg || 'Failed to remove wrong answer card')
        }
      } catch (error) {
        console.error('Error removing wrong answer card:', error)
        this.$message.error('Failed to remove wrong answer card')
      }
    },

    async fetchMyStarredKnowits() {
      try {
        console.log('fetchMyStarredKnowits called, user_id:', this.$store.state.user_id)

        // Fetch starred private cards
        const privateCardsResponse = await postRequest('getStarPrivateCards', {
          user_id: this.$store.state.user_id
        })
        console.log('getStarPrivateCards response:', privateCardsResponse.data)

        // Fetch starred posts
        const postsResponse = await postRequest('getStarPosts', {
          user_id: this.$store.state.user_id
        })
        console.log('getStarPosts response:', postsResponse.data)

        let starredCards = []

        // Process private cards
        if (privateCardsResponse.data.code === 0) {
          const privateCards = (privateCardsResponse.data.data || []).map(card => ({
            id: card.id,
            timestamp: new Date((card.starred_time || card.created_at) * 1000).toISOString(),
            card: {
              id: card.id,
              title: card.title || '',
              content: card.content || '',
              content_type: card.content_type || 'text',
              created_at: card.created_at,
              labels: card.labels || [],
              collection_ids: card.collection_ids || [],
              fileList: card.fileList || [],
              quiz_content: card.quiz_content || null,
              resources: card.resources || []
            }
          }))
          starredCards = [...starredCards, ...privateCards]
        }

        // Process starred posts
        if (postsResponse.data.code === 0) {
          const posts = (postsResponse.data.data || []).map(post => ({
            id: post.id,
            timestamp: new Date((post.created_at) * 1000).toISOString(),
            card: {
              id: post.id,
              title: post.title || '',
              content: post.content || '',
              content_type: post.content_type || 'text',
              created_at: post.created_at,
              labels: post.labels || [],
              collection_ids: []
            }
          }))
          starredCards = [...starredCards, ...posts]
        }

        console.log('Final starredCards:', starredCards)
        this.myStarredKnowits = starredCards
      } catch (error) {
        console.error('Error fetching starred Knowits:', error)
      }
    },

    async viewStarredCard(cardId) {
      // Find the card in the starred list
      const starredItem = this.myStarredKnowits.find(item => item.card.id === cardId)
      if (starredItem) {
        this.selectedCardForReading = starredItem.card
        this.readCardDialogVisible = true
      } else {
        // If not found in the list, fetch it from backend
        try {
          const response = await postRequest('getPrivateCardById', {
            user_id: this.$store.state.user_id,
            card_id: cardId
          })

          if (response.data.code === 0) {
            this.selectedCardForReading = response.data.data
            this.readCardDialogVisible = true
          } else {
            this.$message.error('Failed to load card')
          }
        } catch (error) {
          console.error('Error loading card:', error)
          this.$message.error('Failed to load card')
        }
      }
    },

    async unstarCard(cardId) {
      try {
        const response = await postRequest('StarPrivateCard', {
          user_id: this.$store.state.user_id,
          card_id: cardId
        })

        if (response.data.code === 0) {
          this.myStarredKnowits = this.myStarredKnowits.filter(item => item.card.id !== cardId)
          this.$message.success('Card unstarred successfully')
        } else {
          this.$message.error(response.data.msg || 'Failed to unstar card')
        }
      } catch (error) {
        console.error('Error unstarring card:', error)
        this.$message.error('Failed to unstar card')
      }
    },

    async fetchMyStarredDecks() {
      try {
        const response = await postRequest('getUserStarredCollections', {
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.myStarredDecks = (response.data.data || []).map(deck => ({
            id: deck._id?.$oid || deck._id?.$id || deck.id,
            timestamp: new Date((deck.starred_at || deck.create_time || deck.update_time || Date.now() / 1000) * 1000).toISOString(),
            deck: {
              id: deck._id?.$oid || deck._id?.$id || deck.id,
              title: deck.title || 'Untitled Course',
              description: deck.description || '',
              cover_url: deck.cover_url || '',
              user_name: deck.user_name || 'Unknown',
              user_avatar_address_small: deck.user_avatar_address_small || '',
              user_type: deck.user_type || 'individual',
              knowit_count: deck.knowit_count || 0,
              planned_knowit_count: deck.planned_knowit_count || 0,
              content_count: deck.content_count || 0
            }
          }))
          console.log('Starred decks loaded:', this.myStarredDecks)
        } else {
          console.error('Failed to fetch starred decks:', response.data.msg)
        }
      } catch (error) {
        console.error('Error fetching starred decks:', error)
      }
    },

    viewDeck(deckId) {
      this.$store.dispatch('setTempCollectionId', deckId)
      this.$router.push({ path: '/deck', query: { id: deckId } })
    },

    async unstarDeck(deckId) {
      try {
        const response = await postRequest('unstarCollection', {
          user_id: this.$store.state.user_id,
          collection_id: deckId
        })

        if (response.data.code === 0) {
          this.myStarredDecks = this.myStarredDecks.filter(item => item.deck.id !== deckId)
          this.$message.success('Course unstarred successfully')
        } else {
          this.$message.error(response.data.msg || 'Failed to unstar course')
        }
      } catch (error) {
        console.error('Error unstarring deck:', error)
        this.$message.error('Failed to unstar deck')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.my-activity-page {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.page-title {
  font-size: 32px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
}

.page-subtitle {
  font-size: 16px;
  color: #7f8c8d;
  margin: 0;
}

.activity-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.activity-content {
  padding: 20px;
}

.activity-filters {
  margin-bottom: 20px;
  
  .el-select {
    width: 200px;
  }
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
    display: block;
  }
  
  p {
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 8px 0;
  }
  
  span {
    font-size: 14px;
    color: #adb5bd;
  }
}
</style> 